

import {Fragment, useEffect, useState, useContext} from 'react';

import classes from './Introduction.module.scss';
import LoginContext from '../../../../../store/login-context';
import arrowLeftWhite from '../../../../../assets/icons/arrow-left-white.svg';
import Skip from '../Skip/Skip';
import ProgressBar from '../ProgressBar/ProgressBar';


declare function Translate(key: string): string;

const Introduction = (props) => {
    const ctx = useContext(LoginContext);

    const handleNextClick = () => {
        props.setCurrentScreenStep(ctx.preRegScreenCollection.mainOptions); 
        props.AddUserStep(ctx.preRegScreenCollection.mainOptions);       
    };

    return(
        <Fragment>
            <ProgressBar pbWidth="17%"/>
            <div className={classes.container}>
                <div className={classes.main}>
                    <div className='preRegText'>
                        {Translate('N_General_SignUp_Desc')}
                    </div>
                    <div className={`${classes.boldText} preRegTextBold`}>
                        {Translate('N_General_SignUp_Wizard')}
                    </div>
                
                    <div>
                        <button
                            type='button'
                            id='btnIntroductionNext'
                            className={`pre_reg_btn ${classes.btn}`}   
                            onClick={handleNextClick}                                        
                            >
                                <span>{Translate("N_General_next")}</span>
                                <img src= {arrowLeftWhite}  alt="arrow" className={classes.btn_arrow} />
                        </button>
                    </div>
                </div>
                <div className={classes.skip}>
                    <Skip />
                </div >
            </div>            
        </Fragment>
    );
};
export default Introduction;